import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { IdentityProviderFactory } from 'ish-core/identity-provider/identity-provider.factory';
import { from, isObservable, of, switchMap } from 'rxjs';

export function identityProviderLoginGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const identityProviderFactory = inject(IdentityProviderFactory);

  return of(null).pipe(
    switchMap(() => {
      const result = identityProviderFactory.getInstance().triggerLogin(route, state);

      if (isObservable(result)) {
        return result;
      }
      if (result instanceof Promise) {
        return from(result);
      }
      // boolean or UrlTree
      return of(result);
    })
  );
}
